import { evalAuthHeaders, getEvalBase } from '../../evalApiBase'
import { McpToolListResponse } from './mcpToolsAdminModel'

/**
 * Fetch the MCP tool catalog. The list is small (one row per advertised tool)
 * and unpaginated; `q` is an optional case-insensitive name filter, but callers
 * generally load the whole catalog and filter client-side.
 */
export async function listMcpTools(q?: string): Promise<McpToolListResponse> {
  const query = new URLSearchParams()
  const trimmed = q?.trim()
  if (trimmed) {
    query.set('q', trimmed)
  }
  const suffix = query.toString() ? `?${query}` : ''
  const res = await fetch(`${getEvalBase()}/v1/mcp/tools${suffix}`, {
    headers: evalAuthHeaders(),
  })
  if (!res.ok) {
    throw new Error(`MCP tools list failed: ${res.status}`)
  }
  return res.json()
}
